import React, { useRef, useEffect } from "react";
import { FormattedMessage } from 'react-intl';

function TimeEdit({ value, onChange, onBlur, onRequestClose, onSave }) {
  const editRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (editRef.current && !editRef.current.contains(e.target)) {
        // 关闭时自动触发保存
        onSave && onSave(value);
        onRequestClose && onRequestClose();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onRequestClose, onSave, value]);

  function handleInput(type, val) {
    let v = val.replace(/\D/g, '');
    if (v.length > 2) v = v.slice(0, 2);

    if ((value[type] === '00' || value[type] === '0' || value[type] === '') && v.length === 1) {
      onChange({ ...value, [type]: v });
      return;
    }
    if (v === '') {
      onChange({ ...value, [type]: '' });
      return;
    }
    let num = Number(v);
    if (type === 'h') {
      if (num > 99) num = 99;
    } else {
      if (num > 59) num = 59;
    }
    if (v.length === 2) {
      let max = type === 'h' ? 99 : 59;
      let fixed = Math.min(Number(v), max).toString().padStart(2, '0');
      onChange({ ...value, [type]: fixed });
    } else {
      let max = type === 'h' ? 99 : 59;
      let fixed = Math.min(num, max).toString();
      onChange({ ...value, [type]: fixed });
    }
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') {
      onSave && onSave(value);
      onRequestClose && onRequestClose();
    }
  }

  return (
    <div className="playlist-time-edit-row" ref={editRef} onKeyDown={handleKeyDown}>
      <div className="playlist-time-input-label-group">
        <input
          className="playlist-time-input"
          value={value.h}
          onChange={e => handleInput('h', e.target.value)}
          maxLength={2}
          onBlur={onBlur}
          inputMode="numeric"
          pattern="[0-9]*"
        />
        <span className="playlist-time-label">
          <FormattedMessage id="HOURS" defaultMessage="Hours" />
        </span>
      </div>
      <span className="mx-1" style={{ alignSelf: 'center' }}>:</span>
      <div className="playlist-time-input-label-group">
        <input
          className="playlist-time-input"
          value={value.m}
          onChange={e => handleInput('m', e.target.value)}
          maxLength={2}
          onBlur={onBlur}
          inputMode="numeric"
          pattern="[0-9]*"
        />
        <span className="playlist-time-label">
          <FormattedMessage id="MINUTES" defaultMessage="Minutes" />
        </span>
      </div>
      <span className="mx-1" style={{ alignSelf: 'center' }}>:</span>
      <div className="playlist-time-input-label-group">
        <input
          className="playlist-time-input"
          value={value.s}
          onChange={e => handleInput('s', e.target.value)}
          maxLength={2}
          onBlur={onBlur}
          inputMode="numeric"
          pattern="[0-9]*"
        />
        <span className="playlist-time-label">
          <FormattedMessage id="SECONDS" defaultMessage="Seconds" />
        </span>
      </div>
    </div>
  );
}

export default TimeEdit;
